import { useEffect, useState } from 'react';
import { makeStyles, Box, Switch, Button, CircularProgress, IconButton, Tooltip } from '@material-ui/core';
import SimpleGauge from './SimpleGauge'
import { sendMessage } from '../../../helpers/socketFunctions';
import { transformMqttToJson } from '../../DynamicDiagram/helpers';
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import ModalSettingsBlock from '../../DynamicDashboard/ModalSettingsBlock';
import { getSettingBlock } from '../../DynamicDiagram/helpers';

const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        userSelect: 'none'
    },
    led: {
        width: 30,
        height: 30,
        borderRadius: '50%',
        boxShadow: '0 0 15px rgba(0,0,0,0.2)',
        transition: 'all 0.3s ease',
        userSelect: 'none'
    },
    ledGreen: {
        backgroundColor: '#00e676',
        boxShadow: '0 0 20px 5px rgba(0,255,0,0.6)',
    },
    ledRed: {
        backgroundColor: '#ff1744',
        boxShadow: '0 0 20px 5px rgba(255,0,0,0.6)',
    },
    pulsador: {
        backgroundColor: '#2E7D64',
        color: '#fff',
        '&:hover': {
            backgroundColor: '#4CAF80',
        },
        userSelect: 'none'
    },
}));

export default function ContainerBlockDiagramShowEdit(props) {

    const { indicator, ky, realTimeData, positions, setStateData, stateData, setClose, setMsg, resAutomateList, disabledButtonEdit, setDisabledButtonEdit } = props;
    const classes = useStyles();

    const [localState, setLocalState] = useState({
        automateName: null,
        block: null,
        typeElement: null,
        automateSelected: null
    });

    const [loading, setLoading] = useState(true)
    const [valueBlock, setValueBlock] = useState('')
    const [showError, setShowError] = useState(null)
    const [openModal, setOpenModal] = useState(false)
    const [blockNodeSettings, setBlockNodeSettings] = useState({});

    useEffect(() => {
        const parsed = parseToObject(indicator);
        const automateName = parsed?.[0]?.selectedElement || null;
        const automateSelected = resAutomateList?.data?.find(e => e.nombre === automateName) || null;

        if (automateSelected) {
            let idBlock = parsed?.[1]?.selectedElement?.id
            const block = automateSelected?.diagram?.nodes.find(e => e.id === idBlock)
            const typeElement = parsed?.[2]?.selectedElement || { n: 'ShowTypeBlock' };
            const rangeGauge = parsed?.[2]
            const nodes = automateSelected?.diagram?.nodes

            let res = getSettingBlock(block?.type)
            setBlockNodeSettings(res)

            setLocalState({ automateName, block, typeElement, automateSelected, rangeGauge, nodes });

            const interactionComponents = ['Switch', 'Pulsador', 'ShowTypeBlock'];
            if (interactionComponents.includes(typeElement?.n)) {
                setLoading(false)
            }

            if (['Led', 'Switch', 'Pulsador', 'Gauge', 'ShowTypeBlock'].includes(typeElement?.n)) {
                let kyAux = positions?.i
                let newPositions = stateData?.positions.map((elem) =>
                    elem.i == kyAux ? { ...elem, minH: 1, minW: 1 } : elem
                )
                setStateData({ ...stateData, positions: newPositions })
            }
        }
    }, [indicator, resAutomateList])

    useEffect(() => {
        let identificatorAutomate = localState?.automateSelected?.llave
        let findElementShowValue = realTimeData.find(e => e.identificator === identificatorAutomate)
        let idBlock = localState?.block?.id
        let arry = transformMqttToJson(findElementShowValue?.value?.b)

        if (arry) {
            let findElement = arry.find(e => e?.id == idBlock)
            setValueBlock(findElement?.o)
        } else {
            setShowError(findElementShowValue?.message)
        }

        if (arry || findElementShowValue?.message) {
            setLoading(false)
        }
    }, [realTimeData])

    const parseToObject = (value) => {
        if (typeof value !== "string") return value;
        const trimmed = value.trim();
        if (!trimmed) return value;
        if ((trimmed.startsWith("{") && trimmed.endsWith("}")) ||
            (trimmed.startsWith("[") && trimmed.endsWith("]"))) {
            const jsonString = trimmed
                .replace(/'/g, '"')
                .replace(/\bFalse\b/g, "false")
                .replace(/\bTrue\b/g, "true")
                .replace(/\bNone\b/g, "null");
            return JSON.parse(jsonString);
        }
        return value;
    };

    const { typeElement } = localState || {};
    const typeName = typeElement?.n || null;

    const actionPush = () => {
        let idAux = localState?.block?.a?.id
        function getUTCISOTime() {
            return new Date().toISOString().split('.')[0] + 'Z';
        }
        const now_utc_iso = getUTCISOTime();
        const message = {
            value: {
                mac: localState?.automateSelected?.llave,
                device_type: "auto24v4m",
                delete_websocket: false,
                action: [{ id: idAux, t: now_utc_iso }],
            },
            type: "DOWN_VAR",
        };
        sendMessage(message)
        setLoading(true)
        setTimeout(() => setLoading(false), 2000)
    }

    const handleOpenModal = () => setOpenModal(!openModal)

    const renderElement = () => {
        if (!typeName) return null;

        switch (typeName) {
            case 'Led':
                return (
                    <Box
                        tabIndex={-1}
                        onMouseDown={e => e.preventDefault()}
                        height="100%" width="100%" display="flex" flexDirection="column" alignItems="center"
                    >
                        <Box
                            height="100%" width="100%"
                            display="flex" justifyContent="center" alignItems="center"
                        >
                            <Box
                                mt={3}
                                mb={2}
                                className={`${classes.led} ${valueBlock ? classes.ledGreen : classes.ledRed}`}
                                tabIndex={-1}
                                onMouseDown={e => e.preventDefault()}
                            />
                        </Box>
                    </Box>
                );
            case 'Switch':
                return (
                    <Switch
                        checked={valueBlock}
                        color="primary"
                        tabIndex={-1}
                        onMouseDown={e => e.preventDefault()}
                    />
                );
            case 'Pulsador':
                return (
                    <IconButton
                        onClick={actionPush}
                        className={classes.pulsador}
                        tabIndex={-1}
                        onMouseDown={e => e.preventDefault()}
                    >
                        <PowerSettingsNewIcon />
                    </IconButton>
                );
            case 'Gauge':
                return (
                    <SimpleGauge
                        tabIndex={-1}
                        onMouseDown={e => e.preventDefault()}
                        id={localState?.automateName + ky}
                        min={localState?.rangeGauge?.min}
                        max={localState?.rangeGauge?.max}
                        title={localState?.automateName}
                        descripcion={localState?.block?.n ? localState?.block?.n : localState?.block?.type}
                        value={valueBlock}
                    />
                );
            default:
                return (
                    <Box
                        tabIndex={-1}
                        onMouseDown={e => e.preventDefault()}
                        display="flex"
                        flexDirection="column"
                        alignItems="center"
                        justifyContent="center"
                        height="100%"
                    >
                        <Box>{localState?.block?.n}</Box>
                        <Button
                            color='primary'
                            type="button"
                            onClick={handleOpenModal}
                            disabled={disabledButtonEdit}
                            startIcon={<DriveFileRenameOutlineIcon color="primary" />}
                            tabIndex={-1}
                            onMouseDown={e => e.preventDefault()}
                        >
                            {localState?.block?.type}
                        </Button>
                    </Box>
                )
        }
    };

    return (
        <Tooltip
            title={`${localState?.automateName}-${localState?.block?.n || localState?.block?.type}`}
            arrow
            placement='right'
        >
            <Box
                className={classes.container}
                tabIndex={-1}
                onMouseDown={e => e.preventDefault()}
            >
                {openModal && (
                    <ModalSettingsBlock
                        openModal={openModal}
                        handleOpenModal={handleOpenModal}
                        setLocalState={setLocalState}
                        localState={localState}
                        type={localState?.block?.type}
                        blockNodeSettings={blockNodeSettings}
                        setLoading={setLoading}
                        configBlock={localState?.block}
                        nodes={localState?.nodes}
                        setClose={setClose}
                        setMsg={setMsg}
                        stateData={stateData}
                        setDisabledButtonEdit={setDisabledButtonEdit}
                    />
                )}

                {loading ? (
                    <Box className={classes.circular}>
                        <CircularProgress />
                    </Box>
                ) : showError ? (
                    <Box p={2} textAlign="center">
                        {showError}
                    </Box>
                ) : (
                    renderElement()
                )}
            </Box>
        </Tooltip>
    );
}
